"use client";

import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";

type OverviewChartProps = {
  data: {
    term_name: string;
    applications: number;
    available_beds: number;
    shortage: number;
  }[];
};

export default function OverviewChart({ data }: OverviewChartProps) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-slate-900">
          Applications, Beds, and Shortage by Term
        </h2>
        <p className="text-sm text-slate-500">
          Compare housing demand and supply over time.
        </p>
      </div>

      <div className="h-96">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="term_name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="applications" name="Applications" radius={[8, 8, 0, 0]} />
            <Bar dataKey="available_beds" name="Available Beds" radius={[8, 8, 0, 0]} />
            <Line type="monotone" dataKey="shortage" name="Shortage" strokeWidth={3} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
